<div (click)="openSearchModal()" class="tw:relative tw:text-secondary tw:w-full tw:min-w-16">
	<span
		class="tw:absolute tw:top-0 tw:bottom-0 tw:flex tw:items-center tw:justify-center tw:ps-4 tw:select-none tw:lg:pointer-events-none"
	>
		<mat-icon>search</mat-icon>
	</span>
	<input
		type="text"
		placeholder="Search"
		class="tw:hidden tw:lg:inline tw:border tw:border-grey-line tw:rounded-lg tw:outline-primary tw:h-12 tw:px-4 tw:ps-12 tw:w-full"
	/>
</div>
